import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import Facturation from './models/facturation'
import globalMixin from '../globalMixin'
import accesRenforceMixin from '../accesRenforceMixin'
import Openable from '@/global/viewmodels/openable'
import { DemandeFacturation } from '@/domain/DemandeFacturation'
import { EnumPermission } from '@/domain/permission'
import { RoleEnum } from '@/domain/role'
import { TraitementReeditionFacture_Statut } from '@/domain/TraitementReeditionFacture_Statut'
import { HubConnectionBuilder } from '@microsoft/signalr'
import SendReeditionFactureModel from './models/sendReeditionFactureModel'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin, accesRenforceMixin).extend({
    data() {
        return {
            selectedCompany: null as string | null,
            facturations: new Array<Facturation>(),
            demandeReeditionEmailDestinataire: null as string | null,
            demandeReeditionDescription: null as string | null,
            facture: null as null | Facturation,
            // mailReeditionFacture: null as SendReeditionFactureModel | null,
            demandesFacturations: new Array<DemandeFacturation>(),
            listeFacturesReedition: new Array<Facturation>(),
        }
    },
    mounted() {
        this.loadDemandesReeditionFactures()

        const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()

        connection.start().then(() => {
            connection.on('RefreshDemandesFactures', () => {
                this.loadDemandesReeditionFactures()
            })
        })

        if (this.$database.account.roleEnum != RoleEnum.Client) {
            this.selectedCompany = this.$database.account.codeClientBiobank
            if (this.selectedCompany) this.loadFacturation(this.facturations, this.selectedCompany)
        }
    },
    computed: {
        canSeeSuiviFacture(): boolean {
            return this.$database.account.permissions.indexOf(EnumPermission.SuiviDemandesReeditionFacturation_ReadWrite) !== -1 || (this.$database.account.roleEnum == RoleEnum.Commercial && this.$database.account.permissions.indexOf(EnumPermission.SuiviFacturation_Read) !== -1)
        },
        canChangeStatutDemande(): boolean {
            return this.$database.account.roleEnum != RoleEnum.Commercial
        }
    },
    methods: {
        loadFacturation(facturations: Array<Facturation>, companyName: string) {
            this.promptPasswordCheck().then(a => {
                if (a) {
                    facturations.length = 0
                    this.$loader.go()
                    this.$http
                        .api(`facturation${companyName ? `?codeClient=${companyName}` : ''}`)
                        .get()
                        .then(x => {
                            facturations.length = 0
                            x.data.map((y: Facturation) => facturations.push(y))
                        })
                        .catch(x => this.$swal.toast.errorApi(x))
                        .finally(() => this.$loader.stop())
                }
            })
        },
        loadDemandesReeditionFactures() {
            if (this.canSeeSuiviFacture)
                this.$http
                    .api(`demandesFacturation/all`)
                    .get()
                    .then(x => {
                        this.demandesFacturations = x.data
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
        },
        demandeReeditionFacture() {
            console.log(this.listeFacturesReedition)
            if (!this.listeFacturesReedition.length) return

            this.$http
                .api('demandesFacturation')
                .post({
                    emailDestinataire: this.demandeReeditionEmailDestinataire,
                    description: this.demandeReeditionDescription,
                    codesFacture: this.listeFacturesReedition.map(a => a.code)
                })
                .then(x => {
                    this.$swal.toast.success('La demande de ré-édition de la facture a bien été émise.')
                    this.listeFacturesReedition = []
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        modificationStatutReedition(id: number, statut: string) {
            const statutEnum = statut == 'Envoyee' ? TraitementReeditionFacture_Statut.EnAttenteDeTraitement : statut == 'EnCoursDeTraitement' ? TraitementReeditionFacture_Statut.EnCoursDeTraitement : TraitementReeditionFacture_Statut.Traite

            this.$http
                .api('demandesFacturation/traiter')
                .post({
                    id: id,
                    statut: statutEnum
                })
                .then(x => {
                    this.loadDemandesReeditionFactures()
                    this.loadPastilles()
                    this.$swal.toast.success('La demande de ré-édition a bien été mise à jour.')
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        envoyerMailDemandeReeditionFacture(mailReeditionFacture: SendReeditionFactureModel) {
            const formData = new FormData()

            if (!mailReeditionFacture) return

            formData.append('idDemandeReeditionFacture', mailReeditionFacture.id.toString())
            if (!mailReeditionFacture.mail) {
                this.$swal.toast.error('Aucun mail renseigné.')
                return
            }
            formData.append('mail', mailReeditionFacture.mail)

            if (!mailReeditionFacture.corps) {
                this.$swal.toast.error('Aucun corps renseigné.')
                return
            }
            formData.append('corps', mailReeditionFacture.corps)

            if (!mailReeditionFacture?.files.length) {
                this.$swal.toast.error('Aucun fichier renseigné.')
                return
            }

            for (const file of mailReeditionFacture.files) {
                formData.append('files', file)
            }

            this.$loader.go()

            this.$http
                .api('demandesFacturation/envoyer-duplicata')
                .post(formData)
                .then(x => {
                    this.loadDemandesReeditionFactures()
                    this.loadPastilles()
                    this.$swal.toast.success("Le mail a bien été envoyé.")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }
})
